import styled, { keyframes } from 'styled-components';

export const AnimatedPopupWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const AnimatedPopupContainer = styled.div`
  position: absolute;
  right: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

type PopupProps = {
  isAnimating: boolean;
};

const popupAnimation = keyframes`
  0%
  {
    transform: translate(0, 30px);
    opacity: 0;
  }

  50%
  {
    transform: translate(0, 0);
    opacity: 1
  }
  75%
  {
    transform: translate(0, 0);
    opacity: 1
  }
  100%
  {
    transform: translate(0, -30px);
    opacity: 0;
  }
`;

export const Popup = styled.div<PopupProps>`
  min-height: 28px;
  display: flex;
  border-radius: 30px;
  background-color: ${(props) => props.theme.colors.success};
  align-items: center;
  justify-content: center;
  padding: 4px 25px;
  animation-timing-function: ease;
  animation-duration: 1s;
  animation-name: ${(props) => (props.isAnimating ? popupAnimation : '')};
  transform: translate(0, 30px);
  opacity: 0;
`;
